import { useEffect } from "react";
import InvoiceList from "../../components/invoices/InvoiceList";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function Invoices() {
  const { setInfo } = usePageNameContext();
  
  useEffect(() => {
    setInfo({
      name: "Invoices",
      desc: "View and manage all invoices here",
    });
  }, []);
  
  return <div className="bg-white shadow rounded-lg mt-4 overflow-hidden">
    <InvoiceList />
  </div>;
}

